export const logDebug = (msg?: unknown, ...optionalParams: unknown[]) => {
	const { envConfig } = useEnvConfig()
	if (envConfig.value.environment !== "prod") {
		console.debug(msg, optionalParams)
	}
}

export const log = (msg?: unknown, ...optionalParams: unknown[]) => {
	const { envConfig } = useEnvConfig()
	if (envConfig.value.environment !== "prod") {
		console.log(msg, optionalParams)
	}
}

export const logError = (msg?: unknown, ...optionalParams: unknown[]) => {
	const { envConfig } = useEnvConfig()
	if (envConfig.value.environment !== "prod") {
		console.error(msg, optionalParams)
	}
}

export const logWarn = (msg?: unknown, ...optionalParams: unknown[]) => {
	const { envConfig } = useEnvConfig()
	if (envConfig.value.environment !== "prod") {
		console.warn(msg, optionalParams)
	}
}
